import React from 'react'
import { Select } from 'antd';
import useCustomers from '../../hooks/useCustomers';
import { normalized } from './../../utils/string';

const { Option } = Select;

// Possible util function. Add unit tests
const clientFullName = (client) => `${client.name} ${client.lastName}${client.motherLastName ? ` ${client.motherLastName}` : ''}`;

const ClientSelect = ({ disabled, onChange, style }) => {
    const { data, isLoading } = useCustomers();

    const filterOptionHandler = (input, option) => (normalized(option?.children) ?? '').includes(normalized(input));

    const filterSortHandler = (optionA, optionB) => (clientFullName(optionA) ?? '').toLowerCase().localeCompare((clientFullName(optionB) ?? '').toLowerCase());

    const changeHandler = (id) => {
        const client = data.find(c => c.id === id);
        onChange && onChange(client);
    };

    return <Select
        onChange={changeHandler}
        loading={isLoading}
        showSearch
        disabled={disabled}
        style={style}
        placeholder="Buscar cliente:"
        optionFilterProp="children"
        filterOption={filterOptionHandler}
        filterSort={filterSortHandler}>
        {data && data.map((c) => <Option key={c.id} value={c.id}>{clientFullName(c)}</Option>)}
    </Select>
}

export default ClientSelect;